<ion-header>
  <ion-toolbar class="toolbar-with-closing-button !px-2 md:!px-4">
    <div slot="start" class="flex">
      <dojo-icon-button (click)="closeModal()" [icon]="'times'" />
    </div>
    <ion-title class="common-ion-title">
      {{ 'examdojo.zoom_image' | transloco }}
    </ion-title>
    <div slot="end" class="hidden md:flex md:w-8"></div>
  </ion-toolbar>
</ion-header>

<ion-content (click)="closeModal()">
  <div class="flex h-full w-full items-center justify-center p-2" (click)="$event.stopPropagation()">
    <!-- Zoom Controls -->
    <div class="zoom-controls absolute bottom-4 right-4 z-50 flex flex-row gap-2">
      <dojo-icon-button [icon]="'minus'" (click)="zoomOut()" [matTooltip]="'Zoom Out'" class="zoom-btn" />
      <dojo-icon-button [icon]="'plus'" (click)="zoomIn()" [matTooltip]="'Zoom In'" class="zoom-btn" />
    </div>

    <img
      #zoomImage
      [src]="imageUrl"
      [alt]="'examdojo.preview_image' | transloco"
      class="max-h-full max-w-full object-contain"
      style="image-orientation: from-image; cursor: grab"
      tabindex="0"
      role="img"
    />
  </div>
</ion-content>
